import { Core } from "@faire/design-tokens";
import { BoldFormatting } from "@faire/help-center/components/utils/BoldFormatting";
import { Email } from "@faire/web--source/slate/icons/foundation/Email";
import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled from "styled-components";

export const LoggedOutConfirmationView: React.FC = () => (
  <Column align="flex-start">
    <IconWrapper>
      <Email fontSize="24px" />
    </IconWrapper>
    <Spacer height="3x" />
    <Typography variant="pageHeaderSerifRegular" align="center">
      <StrictLocalMsg
        defaultMessage="We’ve received your request"
        description={{
          text: "Displayed after user sends a ticket through the help center",
        }}
      />
    </Typography>
    <Spacer height="2x" />
    <Typography>
      <StrictLocalMsg
        defaultMessage="You will receive an email from one of our customer care specialists within <boldFormatting>24 business hours</boldFormatting>."
        values={{
          boldFormatting: BoldFormatting,
        }}
      />
    </Typography>
    <Spacer height="4x" />
  </Column>
);

const IconWrapper = styled.div`
  border-radius: 50%;
  padding-top: 20px;
  background-color: ${Core.surface.subdued};
  width: ${getSpacing("8x")};
  height: ${getSpacing("8x")};
  text-align: center;
`;
